// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__10Z8Z","inputWrap":"styles_inputWrap__2H4Yb","input":"styles_input__WmRIz"};